/**
 * This helps cut down on boldified elements. For example:
 *
 * Who dwells with shadows is alone indeed, and loneliness is not the will of God.
 * Would you allow one shadow to usurp the throne that God appointed for your <b>friend</b>,
 * if you but realized its emptiness has left yours empty and unoccupied?  Make no
 * illusion <b>friend</b>, for if you do, it can but take the place of him whom God
 * has called your <b>friend</b>.  And it is he who is your only <b>friend</b> in truth.
 * He brings you gifts that are not of this world, and only he to whom they have been
 * given can make sure that you receive them.  He will place them on your throne when
 * you make room for him on his.
 *
 * Note how the the first and last sentences are pretty unecessary because they have no keywords in them.
 * Why not delete them?
 */

import {
    FootnoteClass,
    ParagraphClass,
    Title,
    type SearchResult,
    getAllWords,
    type SearchTarget,
    DisplayWord,
    SimpleString,
} from "@circleofa/acim-engine"

export function removeUnboldedSentences(paragraph: string): string {
    const boldTagStart = "<b>"
    const boldTagEnd = "</b>"
    const sentences = paragraph.split(/[.!?]\s+/)

    let appendStart = ""
    while (sentences.length > 0) {
        const firstSentence = sentences[0]
        if (!firstSentence.includes(boldTagStart) || !firstSentence.includes(boldTagEnd)) {
            appendStart = "..."
            sentences.shift()
        } else {
            break
        }
    }

    let appendEnd = ""
    while (sentences.length > 0) {
        const lastSentence = sentences[sentences.length - 1]
        if (!lastSentence.includes(boldTagStart) || !lastSentence.includes(boldTagEnd)) {
            appendEnd = ".."
            sentences.pop()
        } else {
            break
        }
    }

    return appendStart + sentences.join(" ") + appendEnd
}
